import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Image1 from "./../Images/Image1.png";
import Image2 from "./../Images/Image2.png";
import Image3 from "./../Images/Image3.png";
import Image4 from "./../Images/Image4.png";

const ic = { fill: "none", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" };

const IconCalendar = ({ s = 22 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="3" y1="10" x2="21" y2="10" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="16" y1="2" x2="16" y2="6" /></svg>);
const IconUsers = ({ s = 22 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><circle cx="9" cy="8" r="4" /><circle cx="17" cy="8" r="3" /><path d="M1 20c0-3.9 3.6-7 8-7s8 3.1 8 7" /><path d="M17 14c2.2 0 5 1.1 5 4v2" /></svg>);
const IconBarChart = ({ s = 22 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><polyline points="4,20 4,4" /><line x1="4" y1="20" x2="20" y2="20" /><rect x="6" y="12" width="3" height="8" /><rect x="11" y="7" width="3" height="13" /><rect x="16" y="4" width="3" height="16" /></svg>);
const IconClock = ({ s = 18 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><circle cx="12" cy="12" r="9" /><polyline points="12,7 12,12 15,15" /></svg>);
const IconCheck = ({ s = 18 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><circle cx="12" cy="12" r="9" /><polyline points="8,12 11,15 16,9" /></svg>);
const IconZap = ({ s = 18 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2" /></svg>);
const IconTrend = ({ s = 18 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><polyline points="22,7 13.5,15.5 8.5,10.5 2,17" /><polyline points="16,7 22,7 22,13" /></svg>);
const IconArrow = ({ s = 16 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><line x1="5" y1="12" x2="19" y2="12" /><polyline points="13,6 19,12 13,18" /></svg>);
const IconMenu = ({ s = 24 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></svg>);
const IconClose = ({ s = 24 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>);
const IconGlobe = ({ s = 18 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><circle cx="12" cy="12" r="9" /><line x1="3" y1="12" x2="21" y2="12" /><path d="M12 3a14.5 14.5 0 010 18M12 3a14.5 14.5 0 000 18" /></svg>);
const IconDownload = ({ s = 16 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" /><polyline points="7,10 12,15 17,10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>);
const IconPhone = ({ s = 20 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.12 1.2 2 2 0 012.11 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.18 6.18l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" /></svg>);
const IconSMS = ({ s = 20 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" /></svg>);
const IconTick = ({ s = 14 }) => (<svg width={s} height={s} viewBox="0 0 24 24" {...ic}><polyline points="6,12 10,16 18,8" /></svg>);
const IconWhatsApp = ({ s = 22 }) => (<svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" /></svg>);
const IconInstagram = ({ s = 18 }) => (<svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>);
const IconFacebook = ({ s = 18 }) => (<svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>);
const IconGooglePlay = ({ s = 17 }) => (<svg width={s} height={s} viewBox="0 0 24 24" fill="white"><path d="M3 20.5v-17c0-.59.34-1.11.84-1.35L13.69 12 3.84 21.85A1.5 1.5 0 013 20.5z" /><path d="M16.81 15.12L6.05 21.34l8.49-8.49 2.27 2.27z" /><path d="M20.16 10.81a1.5 1.5 0 010 2.38l-2.27 1.31-2.5-2.5 2.5-2.5 2.27 1.31z" /><path d="M6.05 2.66l10.76 6.22-2.27 2.27L6.05 2.66z" /></svg>);
const IconApple = ({ s = 17 }) => (<svg width={s} height={s} viewBox="0 0 24 24" fill="white"><path d="M18.71 19.5c-.88 1.24-1.77 2.45-3.11 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.19-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.37 2.83zM13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" /></svg>);

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=DM+Mono:wght@400;500&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --gold: #C9A84C;
    --gold-2: #D9BC6A;
    --gold-pale: rgba(201,168,76,0.1);
    --gold-border: rgba(201,168,76,0.25);
    --dark: #08080C;
    --dark-1: #0F0F16;
    --dark-2: #16161F;
    --dark-3: #1E1E2E;
    --white: #FFFFFF;
    --off-white: #F8F6F2;
    --gray-50: #FAFAFA;
    --gray-100: #F4F4F5;
    --gray-200: #E4E4E7;
    --gray-400: #A1A1AA;
    --gray-500: #71717A;
    --gray-700: #3F3F46;
    --gray-900: #09090B;
    --radius: 12px;
    --radius-lg: 16px;
    --radius-xl: 24px;
    --shadow-gold: 0 12px 40px rgba(201,168,76,0.25);
  }

  .lp { font-family: 'Inter', -apple-system, sans-serif; background: var(--white); color: var(--gray-900); min-height: 100vh; overflow-x: hidden; }
  .lp__container { max-width: 1200px; margin: 0 auto; padding: 0 2.5rem; }

  /* ── NAV ── */
  .lp__nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 100;
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 2.5rem; height: 66px;
    background: rgba(8,8,12,0.5);
    backdrop-filter: blur(24px); -webkit-backdrop-filter: blur(24px);
    border-bottom: 1px solid rgba(255,255,255,0.06);
    transition: background 0.3s, box-shadow 0.3s;
  }
  .lp__nav--scrolled { background: rgba(8,8,12,0.92); box-shadow: 0 4px 32px rgba(0,0,0,0.4); }
  .lp__logo { font-size: 1.45rem; font-weight: 900; letter-spacing: -0.04em; color: var(--white); text-decoration: none; }
  .lp__logo span { color: var(--gold); }
  .lp__nav-links { display: flex; gap: 2rem; list-style: none; align-items: center; }
  .lp__nav-links a { font-size: 0.82rem; font-weight: 500; color: rgba(255,255,255,0.55); text-decoration: none; transition: color 0.2s; }
  .lp__nav-links a:hover { color: var(--white); }
  .lp__nav-right { display: flex; align-items: center; gap: 1rem; }
  .lp__social-btn { display: flex; align-items: center; color: rgba(255,255,255,0.45); text-decoration: none; transition: color 0.2s; }
  .lp__social-btn:hover { color: var(--gold); }
  .lp__lang-wrap { position: relative; }
  .lp__lang-btn {
    display: flex; align-items: center; gap: 0.4rem;
    font-size: 0.75rem; font-weight: 600;
    color: rgba(255,255,255,0.6);
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.1);
    padding: 0.42rem 0.9rem; border-radius: 100px; cursor: pointer; transition: all 0.2s;
  }
  .lp__lang-btn:hover { color: var(--white); background: rgba(255,255,255,0.1); border-color: rgba(255,255,255,0.2); }
  .lp__lang-drop {
    position: absolute; right: 0; top: calc(100% + 8px);
    background: var(--dark-2); border: 1px solid rgba(255,255,255,0.1);
    border-radius: var(--radius); min-width: 160px; z-index: 200;
    box-shadow: 0 20px 60px rgba(0,0,0,0.5); overflow: hidden;
  }
  .lp__lang-opt { display: flex; align-items: center; gap: 0.6rem; width: 100%; padding: 0.65rem 1rem; font-size: 0.82rem; font-weight: 500; color: rgba(255,255,255,0.65); background: transparent; border: none; cursor: pointer; transition: all 0.15s; text-align: left; }
  .lp__lang-opt:hover { background: rgba(255,255,255,0.06); color: var(--white); }
  .lp__lang-opt--active { color: var(--gold); background: rgba(201,168,76,0.08); }
  .lp__nav-cta {
    font-size: 0.8rem; font-weight: 700;
    background: var(--gold); color: var(--dark);
    border: none; padding: 0.55rem 1.35rem;
    border-radius: 100px; cursor: pointer; transition: all 0.25s;
  }
  .lp__nav-cta:hover { background: var(--gold-2); transform: translateY(-1px); box-shadow: var(--shadow-gold); }
  .lp__hamburger { display: none; background: transparent; border: none; color: rgba(255,255,255,0.8); cursor: pointer; padding: 0.25rem; }

  /* ── MOBILE MENU ── */
  .lp__mobile-menu {
    display: none; position: fixed; top: 66px; left: 0; right: 0;
    background: var(--dark-1); border-bottom: 1px solid rgba(255,255,255,0.07);
    padding: 1.25rem 2rem 1.75rem; z-index: 99;
    flex-direction: column; gap: 0; box-shadow: 0 20px 60px rgba(0,0,0,0.5);
  }
  .lp__mobile-menu--open { display: flex; }
  .lp__mobile-menu a { font-size: 0.88rem; font-weight: 500; color: rgba(255,255,255,0.55); text-decoration: none; padding: 0.75rem 0; border-bottom: 1px solid rgba(255,255,255,0.06); transition: color 0.2s; }
  .lp__mobile-menu a:hover { color: var(--white); }
  .lp__mobile-lang-label { font-size: 0.62rem; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: rgba(255,255,255,0.3); margin: 1rem 0 0.6rem; }
  .lp__mobile-lang-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 0.5rem; margin-bottom: 1rem; }
  .lp__mobile-lang-btn { display: flex; flex-direction: column; align-items: center; gap: 0.3rem; padding: 0.65rem; border: 1px solid rgba(255,255,255,0.1); border-radius: var(--radius); background: transparent; cursor: pointer; font-size: 0.7rem; font-weight: 600; color: rgba(255,255,255,0.45); transition: all 0.2s; }
  .lp__mobile-lang-btn--active { border-color: var(--gold); background: rgba(201,168,76,0.1); color: var(--gold); }
  .lp__mobile-cta { font-size: 0.82rem; font-weight: 700; background: var(--gold); color: var(--dark); border: none; padding: 0.9rem; border-radius: var(--radius); cursor: pointer; width: 100%; }

  /* ── LANGUAGE MODAL ── */
  .lp__modal-overlay {
    position: fixed; inset: 0; z-index: 300;
    display: flex; align-items: center; justify-content: center;
    background: rgba(0,0,0,0.75); padding: 1.5rem;
    backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);
  }
  .lp__modal {
    background: var(--dark-2); border: 1px solid rgba(255,255,255,0.1);
    border-radius: var(--radius-xl); max-width: 380px; width: 100%;
    padding: 2.5rem; box-shadow: 0 40px 100px rgba(0,0,0,0.6);
    animation: modalUp 0.3s ease-out;
  }
  @keyframes modalUp { from { opacity:0; transform:translateY(24px) scale(0.97); } to { opacity:1; transform:translateY(0) scale(1); } }
  .lp__modal-icon { width: 3rem; height: 3rem; background: rgba(201,168,76,0.1); border: 1px solid rgba(201,168,76,0.25); border-radius: var(--radius); display: flex; align-items: center; justify-content: center; color: var(--gold); margin: 0 auto 1.25rem; }
  .lp__modal-title { font-size: 1.5rem; font-weight: 800; text-align: center; color: var(--white); margin-bottom: 0.4rem; letter-spacing: -0.03em; }
  .lp__modal-sub { font-size: 0.83rem; color: rgba(255,255,255,0.45); text-align: center; margin-bottom: 1.75rem; }
  .lp__modal-opts { display: flex; flex-direction: column; gap: 0.5rem; }
  .lp__modal-opt { display: flex; align-items: center; justify-content: space-between; width: 100%; padding: 0.85rem 1.1rem; border: 1px solid rgba(255,255,255,0.1); border-radius: var(--radius); background: rgba(255,255,255,0.03); cursor: pointer; font-size: 0.92rem; font-weight: 600; color: var(--white); transition: all 0.2s; }
  .lp__modal-opt:hover { border-color: var(--gold-border); background: var(--gold-pale); color: var(--gold); }
  .lp__modal-opt-left { display: flex; align-items: center; gap: 0.75rem; }
  .lp__modal-hint { font-size: 0.72rem; color: rgba(255,255,255,0.3); text-align: center; margin-top: 1.25rem; }

  /* ── HERO ── */
  .lp__hero {
    min-height: 100vh; padding-top: 66px;
    background: var(--dark-1);
    display: flex; flex-direction: column;
    position: relative; overflow: hidden;
  }
  .lp__hero::before {
    content: '';
    position: absolute; inset: 0; pointer-events: none;
    background:
      radial-gradient(ellipse 80% 70% at 75% 50%, rgba(201,168,76,0.07) 0%, transparent 65%),
      radial-gradient(ellipse 60% 60% at 15% 80%, rgba(30,58,95,0.25) 0%, transparent 60%);
  }
  .lp__hero::after {
    content: ''; position: absolute; inset: 0; pointer-events: none;
    background-image: radial-gradient(rgba(255,255,255,0.025) 1px, transparent 1px);
    background-size: 32px 32px;
  }
  .lp__hero-inner {
    flex: 1; display: grid; grid-template-columns: 1fr 1fr;
    align-items: center; gap: 4rem;
    max-width: 1200px; margin: 0 auto; width: 100%;
    padding: 4rem 2.5rem 5rem;
    position: relative; z-index: 1;
  }
  .lp__hero-left { display: flex; flex-direction: column; gap: 2rem; }
  .lp__badge {
    display: inline-flex; align-items: center; gap: 0.5rem;
    background: rgba(201,168,76,0.08); border: 1px solid rgba(201,168,76,0.22);
    border-radius: 100px; padding: 0.35rem 1rem;
    font-size: 0.68rem; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase;
    color: var(--gold); width: fit-content;
  }
  .lp__badge-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--gold); animation: pulseDot 2s infinite; flex-shrink: 0; }
  @keyframes pulseDot { 0%,100% { opacity:1; transform:scale(1); } 50% { opacity:0.45; transform:scale(1.6); } }
  .lp__h1 { font-size: clamp(2.8rem, 4.5vw, 4.2rem); font-weight: 900; line-height: 1.04; letter-spacing: -0.045em; color: var(--white); }
  .lp__h1 span { background: linear-gradient(135deg, var(--gold) 0%, var(--gold-2) 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .lp__hero-desc { font-size: 1rem; color: rgba(255,255,255,0.5); line-height: 1.75; max-width: 500px; }
  .lp__hero-btns { display: flex; gap: 0.75rem; flex-wrap: wrap; align-items: center; }
  .lp__btn-main {
    display: inline-flex; align-items: center; gap: 0.5rem;
    font-size: 0.85rem; font-weight: 700;
    background: var(--gold); color: var(--dark);
    border: none; padding: 0.9rem 2rem; border-radius: 100px;
    cursor: pointer; transition: all 0.25s; white-space: nowrap;
  }
  .lp__btn-main:hover { background: var(--gold-2); transform: translateY(-2px); box-shadow: var(--shadow-gold); }
  .lp__btn-ghost {
    display: inline-flex; align-items: center; gap: 0.5rem;
    font-size: 0.85rem; font-weight: 600;
    background: transparent; color: rgba(255,255,255,0.65);
    border: 1px solid rgba(255,255,255,0.15); padding: 0.9rem 1.75rem;
    border-radius: 100px; cursor: pointer; transition: all 0.25s; white-space: nowrap;
  }
  .lp__btn-ghost:hover { color: var(--white); border-color: rgba(255,255,255,0.35); background: rgba(255,255,255,0.05); }
  .lp__hero-stats { display: flex; gap: 0; padding-top: 0.5rem; border-top: 1px solid rgba(255,255,255,0.07); }
  .lp__stat-item { display: flex; flex-direction: column; gap: 0.2rem; padding: 1rem 1.5rem 0; }
  .lp__stat-item:first-child { padding-left: 0; }
  .lp__stat-num { font-size: 1.7rem; font-weight: 900; color: var(--white); letter-spacing: -0.045em; line-height: 1; }
  .lp__stat-lbl { font-size: 0.68rem; color: rgba(255,255,255,0.38); font-weight: 500; letter-spacing: 0.02em; }
  .lp__stat-div { width: 1px; background: rgba(255,255,255,0.08); align-self: stretch; margin-top: 1rem; }

  /* Hero Right Phone */
  .lp__hero-right { display: flex; flex-direction: column; align-items: center; gap: 1.75rem; }
  .lp__phone-wrap { position: relative; display: flex; align-items: center; justify-content: center; }
  .lp__phone-glow {
    position: absolute; width: 260px; height: 400px;
    background: radial-gradient(ellipse at center, rgba(201,168,76,0.18) 0%, transparent 70%);
    filter: blur(50px); pointer-events: none;
  }
  .lp__phone-hero {
    width: 190px; aspect-ratio: 9/19;
    background: var(--dark-3); border-radius: 2.75rem;
    border: 2px solid rgba(255,255,255,0.1);
    overflow: hidden; position: relative;
    box-shadow: 0 40px 100px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.04), inset 0 0 0 1px rgba(255,255,255,0.06);
    animation: phoneFloat 5s ease-in-out infinite;
  }
  @keyframes phoneFloat { 0%,100% { transform: translateY(0) rotate(-1.5deg); } 50% { transform: translateY(-18px) rotate(1.5deg); } }
  .lp__phone-hero img { width: 100%; height: 100%; object-fit: cover; display: block; }
  .lp__store-badges { display: flex; flex-direction: column; gap: 0.65rem; width: 100%; max-width: 210px; }
  .lp__store-badge { display: flex; align-items: center; gap: 0.75rem; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.1); border-radius: var(--radius); padding: 0.7rem 1rem; text-decoration: none; transition: all 0.2s; }
  .lp__store-badge:hover { background: rgba(201,168,76,0.07); border-color: rgba(201,168,76,0.25); transform: translateY(-2px); }
  .lp__store-badge-icon { width: 28px; height: 28px; border-radius: 7px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .lp__store-badge p { font-size: 0.48rem; font-weight: 600; letter-spacing: 0.1em; text-transform: uppercase; color: rgba(255,255,255,0.4); line-height: 1; }
  .lp__store-badge strong { font-size: 0.82rem; font-weight: 700; color: var(--white); display: block; margin-top: 3px; }

  /* ── MARQUEE ── */
  .lp__marquee { background: var(--dark-1); border-top: 1px solid rgba(201,168,76,0.15); padding: 0.8rem 0; overflow: hidden; position: relative; z-index: 1; }
  .lp__mq-inner { display: flex; gap: 3rem; white-space: nowrap; animation: mqScroll 28s linear infinite; }
  .lp__mq-inner span { font-size: 0.62rem; font-weight: 700; letter-spacing: 0.2em; text-transform: uppercase; color: rgba(201,168,76,0.65); }
  .lp__mq-inner span::before { content: '◆  '; font-size: 0.35rem; vertical-align: middle; opacity: 0.5; }
  @keyframes mqScroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }

  /* ── SECTIONS ── */
  .lp__section { padding: 7rem 0; }
  .lp__section--dark { background: var(--dark-1); }
  .lp__section--alt { background: var(--off-white); }
  .lp__section-tag {
    display: inline-flex; align-items: center; gap: 0.6rem;
    font-size: 0.62rem; font-weight: 800; letter-spacing: 0.2em; text-transform: uppercase; color: var(--gold);
    margin-bottom: 1.1rem;
  }
  .lp__section-tag::before { content: ''; display: block; width: 22px; height: 2px; background: var(--gold); border-radius: 2px; }
  .lp__h2 { font-size: clamp(2rem, 3.5vw, 2.8rem); font-weight: 900; letter-spacing: -0.04em; line-height: 1.08; color: var(--gray-900); margin-bottom: 1rem; }
  .lp__h2 span { background: linear-gradient(135deg, var(--gold), var(--gold-2)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .lp__h2--light { color: var(--white); }
  .lp__section-sub { font-size: 1rem; color: var(--gray-500); line-height: 1.72; max-width: 540px; }
  .lp__section-sub--light { color: rgba(255,255,255,0.45); }

  /* ── FEATURES ── */
  .lp__feat-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 1.25rem; margin-top: 3.5rem; }
  .lp__feat-card {
    background: var(--white); border: 1px solid var(--gray-200);
    border-radius: var(--radius-lg); padding: 2rem 1.75rem;
    transition: all 0.3s; cursor: default; position: relative; overflow: hidden;
  }
  .lp__feat-card::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px;
    background: linear-gradient(90deg, var(--gold), var(--gold-2));
    transform: scaleX(0); transform-origin: left; transition: transform 0.35s;
  }
  .lp__feat-card:hover::before, .lp__feat-card--active::before { transform: scaleX(1); }
  .lp__feat-card:hover, .lp__feat-card--active {
    border-color: rgba(201,168,76,0.3); transform: translateY(-7px);
    box-shadow: 0 24px 60px rgba(0,0,0,0.08), 0 0 0 1px rgba(201,168,76,0.08);
  }
  .lp__feat-icon-box {
    width: 52px; height: 52px;
    background: linear-gradient(135deg, rgba(201,168,76,0.12), rgba(201,168,76,0.04));
    border: 1px solid rgba(201,168,76,0.2); border-radius: var(--radius);
    display: flex; align-items: center; justify-content: center; color: var(--gold); margin-bottom: 1.5rem;
  }
  .lp__feat-title { font-size: 1.05rem; font-weight: 700; color: var(--gray-900); margin-bottom: 0.6rem; letter-spacing: -0.02em; }
  .lp__feat-desc { font-size: 0.87rem; color: var(--gray-500); line-height: 1.65; }
  .lp__feat-stat { display: inline-block; margin-top: 1.5rem; font-size: 0.68rem; font-weight: 700; letter-spacing: 0.06em; text-transform: uppercase; color: var(--gold); background: rgba(201,168,76,0.08); border: 1px solid rgba(201,168,76,0.18); border-radius: 100px; padding: 0.28rem 0.85rem; }

  /* ── APP SECTION ── */
  .lp__app-inner { display: grid; grid-template-columns: 1fr 420px; align-items: center; gap: 5rem; }
  .lp__app-feat-list { display: flex; flex-direction: column; margin-top: 2rem; }
  .lp__app-feat-row { display: flex; align-items: flex-start; gap: 1rem; padding: 1.25rem 0; border-bottom: 1px solid var(--gray-200); }
  .lp__app-feat-row:first-child { padding-top: 0; }
  .lp__app-feat-row:last-child { border-bottom: none; padding-bottom: 0; }
  .lp__app-feat-dot { width: 36px; height: 36px; min-width: 36px; background: linear-gradient(135deg, var(--gold), var(--gold-2)); border-radius: 9px; display: flex; align-items: center; justify-content: center; color: var(--dark); flex-shrink: 0; }
  .lp__app-feat-title { font-size: 0.95rem; font-weight: 700; color: var(--gray-900); margin-bottom: 0.25rem; letter-spacing: -0.01em; }
  .lp__app-feat-desc { font-size: 0.85rem; color: var(--gray-500); line-height: 1.6; }
  .lp__app-dl-btns { display: flex; gap: 0.75rem; margin-top: 2.5rem; flex-wrap: wrap; }
  .lp__dl-btn { display: flex; align-items: center; gap: 0.7rem; background: var(--gray-900); border: 1px solid transparent; border-radius: var(--radius); padding: 0.72rem 1.15rem; text-decoration: none; transition: all 0.25s; }
  .lp__dl-btn:hover { background: var(--dark-3); transform: translateY(-2px); box-shadow: 0 16px 40px rgba(0,0,0,0.2); }
  .lp__dl-icon { width: 28px; height: 28px; border-radius: 6px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .lp__dl-btn p { font-size: 0.48rem; font-weight: 600; letter-spacing: 0.1em; text-transform: uppercase; color: rgba(255,255,255,0.45); line-height: 1; }
  .lp__dl-btn strong { font-size: 0.82rem; font-weight: 700; color: var(--white); display: block; margin-top: 3px; }
  .lp__app-right { display: flex; justify-content: center; align-items: flex-start; gap: 1rem; }
  .lp__phone-showcase { border-radius: 2.25rem; border: 2px solid var(--gray-200); overflow: hidden; box-shadow: 0 24px 64px rgba(0,0,0,0.12); aspect-ratio: 9/19; flex-shrink: 0; width: 180px; }
  .lp__phone-showcase img { width: 100%; height: 100%; object-fit: cover; display: block; }
  .lp__phone-showcase--offset { margin-top: 48px; width: 160px; box-shadow: 0 16px 40px rgba(0,0,0,0.08); }

  /* ── GALLERY ── */
  .lp__gallery-wrap { background: var(--gray-50); padding: 4rem 0 5rem; }
  .lp__gallery-grid { display: grid; grid-template-columns: repeat(4,1fr); gap: 1rem; margin-top: 2.5rem; }
  .lp__gallery-item { aspect-ratio: 9/16; border-radius: var(--radius-lg); overflow: hidden; border: 1px solid var(--gray-200); transition: transform 0.3s, box-shadow 0.3s; position: relative; }
  .lp__gallery-item:hover { transform: translateY(-6px); box-shadow: 0 24px 60px rgba(0,0,0,0.14); }
  .lp__gallery-item img { width: 100%; height: 100%; object-fit: cover; display: block; transition: transform 0.4s; }
  .lp__gallery-item:hover img { transform: scale(1.04); }

  /* ── BENEFITS DARK ── */
  .lp__benefits-inner { display: grid; grid-template-columns: 1fr 1fr; gap: 5rem; align-items: center; }
  .lp__bene-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-top: 2.5rem; }
  .lp__bene-card { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.07); border-radius: var(--radius-lg); padding: 1.5rem; transition: all 0.3s; }
  .lp__bene-card:hover { background: rgba(201,168,76,0.06); border-color: rgba(201,168,76,0.2); transform: translateY(-3px); }
  .lp__bene-icon { width: 40px; height: 40px; background: rgba(201,168,76,0.1); border: 1px solid rgba(201,168,76,0.2); border-radius: 9px; display: flex; align-items: center; justify-content: center; color: var(--gold); margin-bottom: 1rem; }
  .lp__bene-title { font-size: 0.92rem; font-weight: 700; color: var(--white); margin-bottom: 0.35rem; letter-spacing: -0.01em; }
  .lp__bene-desc { font-size: 0.82rem; color: rgba(255,255,255,0.38); line-height: 1.6; }

  /* Dashboard Card */
  .lp__dash-card { background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: var(--radius-xl); overflow: hidden; }
  .lp__dash-header { padding: 1rem 1.5rem; border-bottom: 1px solid rgba(255,255,255,0.06); display: flex; align-items: center; gap: 0.4rem; }
  .lp__dash-dot { width: 10px; height: 10px; border-radius: 50%; }
  .lp__dash-header-title { font-size: 0.72rem; font-weight: 600; color: rgba(255,255,255,0.4); margin-left: 0.5rem; letter-spacing: 0.06em; text-transform: uppercase; }
  .lp__dash-row { display: flex; justify-content: space-between; align-items: center; padding: 1rem 1.5rem; border-bottom: 1px solid rgba(255,255,255,0.04); transition: background 0.2s; }
  .lp__dash-row:last-child { border-bottom: none; }
  .lp__dash-row:hover { background: rgba(255,255,255,0.02); }
  .lp__dash-lbl { font-size: 0.72rem; font-weight: 500; letter-spacing: 0.05em; text-transform: uppercase; color: rgba(255,255,255,0.32); }
  .lp__dash-val { font-size: 1.45rem; font-weight: 900; color: var(--white); letter-spacing: -0.035em; }
  .lp__dash-val--gold { color: var(--gold); }
  .lp__dash-val--green { color: #34D399; }
  .lp__dash-badge { font-size: 0.58rem; font-weight: 700; letter-spacing: 0.05em; text-transform: uppercase; background: rgba(52,211,153,0.1); color: #34D399; border: 1px solid rgba(52,211,153,0.2); border-radius: 100px; padding: 0.2rem 0.65rem; white-space: nowrap; margin-top: 3px; display: inline-block; }

  /* ── CONTACT ── */
  .lp__contact-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 1.25rem; margin-top: 3rem; }
  .lp__contact-card { background: var(--white); border: 1px solid var(--gray-200); border-radius: var(--radius-lg); padding: 2rem; text-decoration: none; color: inherit; transition: all 0.3s; display: block; }
  .lp__contact-card:hover { border-color: rgba(201,168,76,0.3); transform: translateY(-6px); box-shadow: 0 20px 56px rgba(0,0,0,0.08), 0 0 0 1px rgba(201,168,76,0.08); }
  .lp__contact-icon { width: 50px; height: 50px; background: linear-gradient(135deg, rgba(201,168,76,0.12), rgba(201,168,76,0.04)); border: 1px solid rgba(201,168,76,0.22); border-radius: var(--radius); display: flex; align-items: center; justify-content: center; color: var(--gold); margin-bottom: 1.25rem; }
  .lp__contact-type { font-size: 0.6rem; font-weight: 800; letter-spacing: 0.16em; text-transform: uppercase; color: var(--gold); margin-bottom: 0.4rem; }
  .lp__contact-title { font-size: 1.1rem; font-weight: 700; color: var(--gray-900); letter-spacing: -0.02em; }
  .lp__contact-num { font-size: 0.83rem; font-weight: 500; color: var(--gray-400); margin-top: 0.5rem; font-family: 'DM Mono', monospace; }

  /* ── CTA ── */
  .lp__cta { background: var(--dark-1); position: relative; overflow: hidden; padding: 8rem 0; }
  .lp__cta::before { content: ''; position: absolute; inset: 0; background: radial-gradient(ellipse 80% 70% at 50% 50%, rgba(201,168,76,0.07) 0%, transparent 65%); pointer-events: none; }
  .lp__cta::after { content: ''; position: absolute; inset: 0; background-image: radial-gradient(rgba(255,255,255,0.02) 1px, transparent 1px); background-size: 32px 32px; pointer-events: none; }
  .lp__cta-inner { position: relative; z-index: 1; text-align: center; max-width: 660px; margin: 0 auto; padding: 0 2.5rem; }
  .lp__cta-h2 { font-size: clamp(2.2rem, 4vw, 3.4rem); font-weight: 900; line-height: 1.08; color: var(--white); letter-spacing: -0.045em; margin-bottom: 1rem; }
  .lp__cta-h2 span { background: linear-gradient(135deg, var(--gold), var(--gold-2)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .lp__cta-sub { font-size: 0.97rem; color: rgba(255,255,255,0.42); line-height: 1.72; margin-bottom: 2.5rem; }
  .lp__cta-btns { display: flex; gap: 0.75rem; justify-content: center; flex-wrap: wrap; }
  .lp__cta-btn1 { display: inline-flex; align-items: center; gap: 0.5rem; font-size: 0.85rem; font-weight: 700; background: var(--gold); color: var(--dark); border: none; padding: 0.9rem 2.25rem; border-radius: 100px; cursor: pointer; transition: all 0.25s; }
  .lp__cta-btn1:hover { background: var(--gold-2); transform: translateY(-2px); box-shadow: var(--shadow-gold); }
  .lp__cta-btn2 { display: inline-flex; align-items: center; gap: 0.5rem; font-size: 0.85rem; font-weight: 600; background: transparent; color: rgba(255,255,255,0.65); border: 1px solid rgba(255,255,255,0.15); padding: 0.9rem 2.25rem; border-radius: 100px; cursor: pointer; transition: all 0.25s; }
  .lp__cta-btn2:hover { color: var(--white); border-color: rgba(255,255,255,0.35); background: rgba(255,255,255,0.05); }

  /* ── FOOTER ── */
  .lp__footer { background: var(--dark-1); border-top: 1px solid rgba(255,255,255,0.06); padding: 1.75rem 2.5rem; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 1rem; }
  .lp__footer-logo { font-size: 1.1rem; font-weight: 900; color: var(--white); letter-spacing: -0.03em; }
  .lp__footer-logo span { color: var(--gold); }
  .lp__footer-copy { font-size: 0.72rem; color: rgba(255,255,255,0.28); }
  .lp__footer-links { display: flex; gap: 1.5rem; align-items: center; }
  .lp__footer-links a { font-size: 0.72rem; color: rgba(255,255,255,0.38); text-decoration: none; transition: color 0.2s; display: flex; align-items: center; }
  .lp__footer-links a:hover { color: var(--gold); }

  /* ── RESPONSIVE ── */
  @media (max-width: 960px) {
    .lp__nav-links, .lp__nav-right { display: none; }
    .lp__hamburger { display: flex; }
    .lp__hero-inner { grid-template-columns: 1fr; padding: 3rem 1.5rem 4rem; gap: 2rem; }
    .lp__hero-right { display: none; }
    .lp__feat-grid { grid-template-columns: 1fr; }
    .lp__app-inner { grid-template-columns: 1fr; }
    .lp__app-right { display: none; }
    .lp__benefits-inner { grid-template-columns: 1fr; gap: 3rem; }
    .lp__gallery-grid { grid-template-columns: repeat(2,1fr); }
    .lp__contact-grid { grid-template-columns: 1fr; }
    .lp__footer { flex-direction: column; align-items: center; text-align: center; }
    .lp__section { padding: 4.5rem 0; }
    .lp__hero-stats { flex-wrap: wrap; }
  }
  @media (max-width: 580px) {
    .lp__bene-grid { grid-template-columns: 1fr; }
    .lp__hero-btns { flex-direction: column; align-items: flex-start; }
    .lp__cta-btns { flex-direction: column; align-items: center; }
  }
`;

const GOOGLE_PLAY = "https://play.google.com/store/apps/details?id=com.mohammad1998a.bokahitbusiness";
const APP_STORE = "https://apps.apple.com/us/app/bokahitbusiness/id6759691684";

const LANGUAGES = [
  { code: "sv", name: "Svenska", flag: "🇸🇪" },
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "ar", name: "العربية", flag: "🇸🇦" },
];

const MARQUEE_ITEMS = [
  "Smart Scheduling", "Client Management", "Analytics & Insights",
  "Push Notifications", "Works Offline", "Real-Time Sync",
  "Smart Scheduling", "Client Management", "Analytics & Insights",
  "Push Notifications", "Works Offline", "Real-Time Sync",
];

const LandingPage = () => {
  const { t, i18n } = useTranslation();

  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeFeat, setActiveFeat] = useState(0);
  const [showLangModal, setShowLangModal] = useState(false);
  const [showLangDrop, setShowLangDrop] = useState(false);

  useEffect(() => {
    try {
      const visited = localStorage.getItem("hasVisited");
      const lang = localStorage.getItem("lang");
      if (!visited) {
        setShowLangModal(true);
      } else if (lang) {
        i18n.changeLanguage(JSON.parse(lang));
      }
    } catch {
      localStorage.removeItem("lang");
      localStorage.removeItem("hasVisited");
      setShowLangModal(true);
    }
  }, [i18n]);

  useEffect(() => {
    const id = setInterval(() => setActiveFeat((p) => (p + 1) % 3), 3000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const selectLang = (code) => {
    try {
      i18n.changeLanguage(code);
      localStorage.setItem("lang", JSON.stringify(code));
      localStorage.setItem("hasVisited", "true");
      setShowLangModal(false);
    } catch { /**/ }
  };
  const changeLang = (code) => {
    try {
      i18n.changeLanguage(code);
      localStorage.setItem("lang", JSON.stringify(code));
      setShowLangDrop(false);
    } catch { /**/ }
  };
  const scrollToApp = () => {
    document.getElementById("app")?.scrollIntoView({ behavior: "smooth", block: "start" });
    setMobileOpen(false);
  };

  const currentLang = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];
  const isRtl = i18n.language === "ar";

  const features = [
    { icon: <IconCalendar s={22} />, title: t("SmartScheduling"), desc: t("SmartSchedulingDesc"), stat: t("SmartSchedulingStat") },
    { icon: <IconUsers s={22} />, title: t("ClientManagement"), desc: t("ClientManagementDesc"), stat: t("ClientManagementStat") },
    { icon: <IconBarChart s={22} />, title: t("AnalyticsInsights"), desc: t("AnalyticsInsightsDesc"), stat: t("AnalyticsInsightsStat") },
  ];

  const benefits = [
    { icon: <IconClock s={18} />, title: t("SaveHoursDaily"), desc: t("SaveHoursDesc") },
    { icon: <IconCheck s={18} />, title: t("NeverMissAppointment"), desc: t("NeverMissDesc") },
    { icon: <IconZap s={18} />, title: t("InstantSetup"), desc: t("InstantSetupDesc") },
    { icon: <IconTrend s={18} />, title: t("BoostRevenue"), desc: t("BoostRevenueDesc") },
  ];

  const appFeats = [
    { icon: <IconTick s={14} />, title: t("RealTimeSync"), desc: t("RealTimeSyncDesc") },
    { icon: <IconZap s={14} />, title: t("PushNotifications"), desc: t("PushNotificationsDesc") },
    { icon: <IconTick s={14} />, title: t("WorksOffline"), desc: t("WorksOfflineDesc") },
  ];

  const dashRows = [
    { lbl: t("TodaysAppointments"), val: "24", cls: "lp__dash-val--green" },
    { lbl: t("ClientSatisfaction"), val: "4.9 ★", cls: "lp__dash-val--gold" },
    { lbl: t("ThisMonthRevenue"), val: "$47,250", badge: t("PercentageFromLastMonth") },
    { lbl: t("ActiveClients"), val: "156", cls: "" },
    { lbl: t("ShowRate"), val: "98%", cls: "lp__dash-val--green" },
  ];

  return (
    <>
      <style>{styles}</style>
      <div className="lp" dir={isRtl ? "rtl" : "ltr"}>

        {/* ── Language Modal ── */}
        {showLangModal && (
          <div className="lp__modal-overlay">
            <div className="lp__modal">
              <div className="lp__modal-icon"><IconGlobe s={24} /></div>
              <h2 className="lp__modal-title">Welcome to Bokahit!</h2>
              <p className="lp__modal-sub">Select your preferred language to continue</p>
              <div className="lp__modal-opts">
                {LANGUAGES.map((l) => (
                  <button key={l.code} className="lp__modal-opt" onClick={() => selectLang(l.code)}>
                    <span className="lp__modal-opt-left">
                      <span style={{ fontSize: "1.4rem" }}>{l.flag}</span>
                      {l.name}
                    </span>
                    <IconArrow s={15} />
                  </button>
                ))}
              </div>
              <p className="lp__modal-hint">You can change this later from the menu</p>
            </div>
          </div>
        )}

        {/* ── Navbar ── */}
        <nav className={`lp__nav${scrolled ? " lp__nav--scrolled" : ""}`}>
          <a href="#" className="lp__logo">Boka<span>hit</span></a>
          <ul className="lp__nav-links">
            <li><a href="#features">{t("Features")}</a></li>
            <li><a href="#app">{t("MobileApp")}</a></li>
            <li><a href="#benefits">{t("Benefits")}</a></li>
            <li><a href="#contact">{t("Contact") || "Contact"}</a></li>
          </ul>
          <div className="lp__nav-right">
            <a href="https://www.instagram.com/neholtorem/" target="_blank" rel="noopener noreferrer" className="lp__social-btn" aria-label="Instagram">
              <IconInstagram s={18} />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61583627140017" target="_blank" rel="noopener noreferrer" className="lp__social-btn" aria-label="Facebook">
              <IconFacebook s={18} />
            </a>
            <div className="lp__lang-wrap">
              <button className="lp__lang-btn" onClick={() => setShowLangDrop((p) => !p)}>
                <IconGlobe s={13} />
                <span>{currentLang.flag}</span>
                <span>{currentLang.name}</span>
              </button>
              {showLangDrop && (
                <div className="lp__lang-drop">
                  {LANGUAGES.map((l) => (
                    <button key={l.code} className={`lp__lang-opt${i18n.language === l.code ? " lp__lang-opt--active" : ""}`} onClick={() => changeLang(l.code)}>
                      <span style={{ fontSize: "1.1rem" }}>{l.flag}</span>
                      {l.name}
                    </button>
                  ))}
                </div>
              )}
            </div>
            <button className="lp__nav-cta" onClick={scrollToApp}>{t("GetStarted")}</button>
          </div>
          <button className="lp__hamburger" onClick={() => setMobileOpen((p) => !p)} aria-label="Toggle menu">
            {mobileOpen ? <IconClose s={24} /> : <IconMenu s={24} />}
          </button>
        </nav>

        {/* ── Mobile Menu ── */}
        <div className={`lp__mobile-menu${mobileOpen ? " lp__mobile-menu--open" : ""}`}>
          <a href="#features" onClick={() => setMobileOpen(false)}>{t("Features")}</a>
          <a href="#app" onClick={() => setMobileOpen(false)}>{t("MobileApp")}</a>
          <a href="#benefits" onClick={() => setMobileOpen(false)}>{t("Benefits")}</a>
          <a href="#contact" onClick={() => setMobileOpen(false)}>{t("Contact") || "Contact"}</a>
          <div className="lp__mobile-lang-label">Language</div>
          <div className="lp__mobile-lang-grid">
            {LANGUAGES.map((l) => (
              <button key={l.code} className={`lp__mobile-lang-btn${i18n.language === l.code ? " lp__mobile-lang-btn--active" : ""}`} onClick={() => { changeLang(l.code); setMobileOpen(false); }}>
                <span style={{ fontSize: "1.4rem" }}>{l.flag}</span>
                {l.name}
              </button>
            ))}
          </div>
          <button className="lp__mobile-cta" onClick={scrollToApp}>{t("GetStarted")}</button>
        </div>

        {/* ── Hero ── */}
        <section className="lp__hero">
          <div className="lp__hero-inner">
            <div className="lp__hero-left">
              <div className="lp__badge">
                <span className="lp__badge-dot" />
                {t("TrustedByProfessionals")}
              </div>
              <h1 className="lp__h1">
                {t("AppointmentManagement")}
                <br />
                <span>{t("Simplified")}</span>
              </h1>
              <p className="lp__hero-desc">{t("HeroDescription")}</p>
              <div className="lp__hero-btns">
                <button className="lp__btn-main" onClick={scrollToApp}>
                  {t("StartFreeTrial")} <IconArrow s={15} />
                </button>
                <button className="lp__btn-ghost">{t("WatchDemo")}</button>
              </div>
              <div className="lp__hero-stats">
                {[
                  { n: "10K+", l: t("ActiveUsers") },
                  { n: "1M+", l: t("AppointmentsBooked") },
                  { n: "99.9%", l: t("Uptime") },
                  { n: "4.9★", l: t("UserRating") },
                ].map((s, i) => (
                  <React.Fragment key={s.l}>
                    {i > 0 && <div className="lp__stat-div" />}
                    <div className="lp__stat-item">
                      <div className="lp__stat-num">{s.n}</div>
                      <div className="lp__stat-lbl">{s.l}</div>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>

            <div className="lp__hero-right">
              <div className="lp__phone-wrap">
                <div className="lp__phone-glow" />
                <div className="lp__phone-hero">
                  <img src={Image1} alt="App screenshot" onError={(e) => { e.target.style.display = "none"; }} />
                </div>
              </div>
              <div className="lp__store-badges">
                <a href={GOOGLE_PLAY} target="_blank" rel="noopener noreferrer" className="lp__store-badge">
                  <div className="lp__store-badge-icon" style={{ background: "#2e7d32" }}><IconGooglePlay s={16} /></div>
                  <div>
                    <p>{t("GetItOnGooglePlay")}</p>
                    <strong>{t("GooglePlay")}</strong>
                  </div>
                </a>
                <a href={APP_STORE} target="_blank" rel="noopener noreferrer" className="lp__store-badge">
                  <div className="lp__store-badge-icon" style={{ background: "#1565c0" }}><IconApple s={16} /></div>
                  <div>
                    <p>{t("DownloadOnTheAppStore")}</p>
                    <strong>{t("AppStore")}</strong>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* ── Marquee ── */}
        <div className="lp__marquee">
          <div className="lp__mq-inner">
            {MARQUEE_ITEMS.map((item, i) => <span key={i}>{item}</span>)}
          </div>
        </div>

        {/* ── Features ── */}
        <section id="features" className="lp__section">
          <div className="lp__container">
            <div className="lp__section-tag">{t("Features")}</div>
            <h2 className="lp__h2">{t("EverythingYouNeedTo")} <span>{t("Succeed")}</span></h2>
            <p className="lp__section-sub">{t("BuiltForProfessionals")}</p>
            <div className="lp__feat-grid">
              {features.map((f, i) => (
                <div key={i} className={`lp__feat-card${activeFeat === i ? " lp__feat-card--active" : ""}`} onMouseEnter={() => setActiveFeat(i)}>
                  <div className="lp__feat-icon-box">{f.icon}</div>
                  <div className="lp__feat-title">{f.title}</div>
                  <div className="lp__feat-desc">{f.desc}</div>
                  <div className="lp__feat-stat">{f.stat}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── App Section ── */}
        <section id="app" className="lp__section lp__section--alt" style={{ scrollMarginTop: "66px" }}>
          <div className="lp__container">
            <div className="lp__app-inner">
              <div>
                <div className="lp__section-tag">{t("AvailableOnMobile")}</div>
                <h2 className="lp__h2">{t("ManageEverything")} <span>{t("OnTheGo")}</span></h2>
                <p className="lp__section-sub">{t("MobileAppFullDescription")}</p>
                <div className="lp__app-feat-list">
                  {appFeats.map((f, i) => (
                    <div className="lp__app-feat-row" key={i}>
                      <div className="lp__app-feat-dot">{f.icon}</div>
                      <div>
                        <div className="lp__app-feat-title">{f.title}</div>
                        <div className="lp__app-feat-desc">{f.desc}</div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="lp__app-dl-btns">
                  <a href={GOOGLE_PLAY} target="_blank" rel="noopener noreferrer" className="lp__dl-btn">
                    <div className="lp__dl-icon" style={{ background: "#2e7d32" }}><IconGooglePlay s={17} /></div>
                    <div><p>{t("GetItOnGooglePlay")}</p><strong>{t("GooglePlay")}</strong></div>
                  </a>
                  <a href={APP_STORE} target="_blank" rel="noopener noreferrer" className="lp__dl-btn">
                    <div className="lp__dl-icon" style={{ background: "#1565c0" }}><IconApple s={17} /></div>
                    <div><p>{t("DownloadOnTheAppStore")}</p><strong>{t("AppStore")}</strong></div>
                  </a>
                </div>
              </div>
              <div className="lp__app-right">
                <div className="lp__phone-showcase">
                  <img src={Image1} alt="App screenshot 1" onError={(e) => { e.target.style.display = "none"; }} />
                </div>
                <div className="lp__phone-showcase lp__phone-showcase--offset">
                  <img src={Image2} alt="App screenshot 2" onError={(e) => { e.target.style.display = "none"; }} />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── Gallery ── */}
        <div className="lp__gallery-wrap">
          <div className="lp__container">
            <div className="lp__section-tag">{t("SeeItInAction")}</div>
            <h2 className="lp__h2" style={{ marginBottom: "0" }}>{t("SeeItInAction")}</h2>
            <div className="lp__gallery-grid">
              {[Image1, Image2, Image3, Image4].map((img, i) => (
                <div className="lp__gallery-item" key={i}>
                  <img src={img} alt={`Screenshot ${i + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Benefits + Dashboard ── */}
        <section id="benefits" className="lp__section lp__section--dark">
          <div className="lp__container">
            <div className="lp__benefits-inner">
              <div>
                <div className="lp__section-tag">{t("WhyProfessionalsChoose")}</div>
                <h2 className="lp__h2 lp__h2--light">
                  {t("WhyProfessionalsChoose")} <span>{t("NeholTorem")}</span>
                </h2>
                <p className="lp__section-sub lp__section-sub--light">{t("BenefitsDescription")}</p>
                <div className="lp__bene-grid">
                  {benefits.map((b, i) => (
                    <div className="lp__bene-card" key={i}>
                      <div className="lp__bene-icon">{b.icon}</div>
                      <div className="lp__bene-title">{b.title}</div>
                      <div className="lp__bene-desc">{b.desc}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <div className="lp__dash-card">
                  <div className="lp__dash-header">
                    <div className="lp__dash-dot" style={{ background: "#EF4444" }} />
                    <div className="lp__dash-dot" style={{ background: "#F59E0B" }} />
                    <div className="lp__dash-dot" style={{ background: "#34D399" }} />
                    <span className="lp__dash-header-title">Live Dashboard</span>
                  </div>
                  {dashRows.map((row, i) => (
                    <div className="lp__dash-row" key={i}>
                      <div className="lp__dash-lbl">{row.lbl}</div>
                      <div style={{ textAlign: "right" }}>
                        <div className={`lp__dash-val ${row.cls || ""}`}>{row.val}</div>
                        {row.badge && <div className="lp__dash-badge">{row.badge}</div>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── Contact ── */}
        <section id="contact" className="lp__section">
          <div className="lp__container">
            <div className="lp__section-tag">{t("Contact") || "Contact"}</div>
            <h2 className="lp__h2">{t("NeedHelpOrHaveQuestions")}</h2>
            <p className="lp__section-sub">{t("ContactOurSupportTeam")}</p>
            <div className="lp__contact-grid">
              <a href="https://wa.me/46790205074" target="_blank" rel="noopener noreferrer" className="lp__contact-card">
                <div className="lp__contact-icon"><IconWhatsApp s={22} /></div>
                <div className="lp__contact-type">WhatsApp</div>
                <div className="lp__contact-title">{t("ChatWithUs") || "Chat with us"}</div>
                <div className="lp__contact-num">+46 79 020 50 74</div>
              </a>
              <a href="tel:+46790205074" className="lp__contact-card">
                <div className="lp__contact-icon"><IconPhone s={22} /></div>
                <div className="lp__contact-type">{t("Phone") || "Phone"}</div>
                <div className="lp__contact-title">{t("CallUs") || "Call us directly"}</div>
                <div className="lp__contact-num">+46 79 020 50 74</div>
              </a>
              <a href="sms:+46790205074" className="lp__contact-card">
                <div className="lp__contact-icon"><IconSMS s={22} /></div>
                <div className="lp__contact-type">{t("SMS") || "SMS"}</div>
                <div className="lp__contact-title">{t("TextUs") || "Send us a text"}</div>
                <div className="lp__contact-num">+46 79 020 50 74</div>
              </a>
            </div>
          </div>
        </section>

        {/* ── CTA ── */}
        <div className="lp__cta">
          <div className="lp__cta-inner">
            <h2 className="lp__cta-h2">
              {t("ReadyToTransform")} <span>your business?</span>
            </h2>
            <p className="lp__cta-sub">{t("CTADescription")}</p>
            <div className="lp__cta-btns">
              <button className="lp__cta-btn1" onClick={scrollToApp}>
                <IconDownload s={16} /> {t("DownloadApp")}
              </button>
              <button className="lp__cta-btn2" onClick={scrollToApp}>
                {t("StartFreeTrial")} <IconArrow s={15} />
              </button>
            </div>
          </div>
        </div>

        {/* ── Footer ── */}
        <footer className="lp__footer">
          <div className="lp__footer-logo">Boka<span>hit</span></div>
          <div className="lp__footer-copy">{t("CopyrightMainPage")}</div>
          <div className="lp__footer-links">
            <a href="#">{t("Privacy")}</a>
            <a href="#">{t("Terms")}</a>
            <a href="https://www.instagram.com/bokahitbusiness/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <IconInstagram s={16} />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61576819842993" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <IconFacebook s={16} />
            </a>
          </div>
        </footer>

      </div>
    </>
  );
};

export default LandingPage;
